import { Card, CardBody } from '@change/ds-core-ui/Card';
import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';

/** Shown in place of the decision-maker cards when inference failed or found none, or the starter removed them all. */
export const DecisionMakersEmpty: React.FC<EmptyProps> = () => (
	// the section's focus fallback lands here after the last Remove, instead of dropping focus to the page
	<div
		data-focus-target="decision-makers-empty"
		className="focus-visible:outline-stroke-focus block rounded-lg focus-visible:outline-2 focus-visible:outline-offset-2"
		data-qa="decision-makers-empty"
	>
		<Card className="bg-background-base w-full [--card-padding:1.5rem]">
			<CardBody>
				<Text as="p" className="text-typography-weak">
					<Translate value="corgi.start_a_petition.decision_makers.empty" />
				</Text>
			</CardBody>
		</Card>
	</div>
);
